module.exports = __webpack_public_path__ + "static/media/avatars_female_25.4c00ff17.png";